export default __webpack_public_path__ + "static/media/element_9.cd53b293.jpg";